const samplePopup = {
    emits: ['close'],
    data() {
        return {
            materials: [],
            errors: null,
            loading: false,
            isMounted: false,
            cartAddUrl: '/cart/add.js',
            cartUpdateUrl: '/cart/update.js',
            cartUrl: '/cart.js',
            fetchHeaders: new Headers({'pragma':'no-cache','cache-control':'no-store','Content-Type':'application/json'}),
            samples: window.sampleOptions
        }
    },
    props: {
        item: Object,
        show: Boolean,
    },
    watch: {
        show() {
            this.errors = null;
            this.materials = [];
        },
        materials(newNaterials) {
            if(newNaterials.length > 0) {
                this.errors = null;
            }
        },
    },
    computed: {
        image() {
            let img = '';
            if(this.item) {
                if(this.item.thumbnail_url) {
                    img = this.item.thumbnail_url;
                } else if(this.item.image) {
                    img = this.item.image;
                }
                if(!img.startsWith('https')) {
                    img = 'https:' + img;
                }
                if(this.type.includes('canvas') && !img.includes('limitless-photos')) {
                    img = 'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos/?frame=canvas2&style=style1&size=600&url=' + img;
                }
            }

            return img;
        },
        type() {
            return this.item && this.item.hasOwnProperty('type') && this.item.type ? this.item.type.toLowerCase() : 'mural';
        },
        url() {
            return (this.item.hasOwnProperty('url') && this.item.url) ? this.item.url : '/collections/explore?id=' + this.item.id;
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        onSubmit() {
            if(this.type.includes('mural') && this.materials.length === 0) {
                this.errors = true;
                return false;
            } else {
                this.loading = true;
                let properties = {
                    '_id': this.item.id,
                    '_title': this.item.title,
                    '_image': this.image,
                    '_type': this.type,
                    '_url': this.url,
                };
                if(this.materials.length > 0) {
                    properties['Materials'] = this.materials.join(', ');
                }
                const formData = new FormData();
                formData.set('id',window.sampleVariantId);
                formData.set('quantity',1);
                formData.set('sections', ["mini-cart"]);

                for(const key in properties) {
                    formData.set(`properties[${key}]`,properties[key]);
                }
                this.addToCart(formData);
            }
        },
        addToCart(formData) {
            let ms = Date.now();
            let url = this.cartUrl + '?_=' + ms;
            fetch(url,{method: 'GET', headers: this.fetchHeaders})
                .then((response) => response.json())
                .then((parsedState) => {
                    return new Promise((resolve, reject) => {
                        if(parsedState.items.length === 0) {
                            resolve();
                        } else {
                            const samplesFound = parsedState.items.filter((item) => item.handle === 'sample' && this.item.id === parseInt(item.properties['_id']) && this.type === item.properties['_type']);
                            if(!samplesFound || samplesFound.length === 0) {
                                resolve();
                            } else {
                                let updates = {};
                                samplesFound.forEach((sample) => {
                                    updates[sample.key] = 0;
                                });
                                const params = {
                                    "updates": updates
                                };
                                let body = JSON.stringify(params);
                                fetch(this.cartUpdateUrl, {method: 'POST', headers: this.fetchHeaders , body})
                                    .then((response) => response.json())
                                    .then((response) => {
                                    })
                                    .catch((e) => {
                                        console.error(e);
                                    }).finally(() => {
                                    setTimeout(() => {
                                        resolve();
                                    },250);
                                });
                            }
                        }
                    });
                })
                .then(() => {
                    fetch(this.cartAddUrl, {method: 'POST', body: formData})
                        .then((response) => response.json())
                        .then((response) => {
                        })
                        .catch((e) => {
                            console.error(e);
                        }).finally(() => {
                        fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
                            const cartContent = await response2.json();
                            document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
                                bubbles: true,
                                detail: {
                                    cart: cartContent
                                }
                            }));
                            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                                bubbles: true,
                                detail: {
                                    cart: cartContent
                                }
                            }));
                            document.documentElement.dispatchEvent(new CustomEvent("cart-notification:show", {
                                bubbles: true,
                                cancelable: true,
                                detail: {
                                    status: "success",
                                    error: ""
                                }
                            }));
                            this.loading = false;
                            this.close();
                        });
                    });
                });
        }
    },
    mounted () {
        setTimeout(() => {
            this.isMounted = true;
        },250);
    },
    template: `
  <transition name="modal">
    <div class="modal-mask" v-if="show">
      <div class="modal-wrapper" @click="close()">
        <div class="modal-container sample-popup-container" @click.stop="">
          <div class="modal-body">
            <div class="sample-order-form">
              <form action="/" method="post" @submit.prevent="onSubmit">
                <div class="sample-form" :class="{'loading': loading}">
                  <div class="sample-image">
                    <img :src="image" alt="">
                  </div>
                  <p class="sample-id">Item #: {{item.id}}</p>
                  <div class="title" v-if="item && type.includes('mural')">Select Substrate Media</div>
                  <div class="sample-options" v-if="item && type.includes('mural')">
                    <div v-for="(sample, index) in samples">
                      <p><strong>{{sample.title}}</strong></p>
                      <ul>
                        <li v-for="(sampleOption, jindex) in sample.options">
                          <input :id="'sample-'+index+'-'+jindex" type="checkbox" :value="sampleOption" v-model="materials" class="checkbox">
                          <label :for="'sample-'+index+'-'+jindex">{{sampleOption}}</label>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <p class="error" v-if="errors">Please select sample material</p>
                  <div class="actions">
                    <button type="submit" class="button btn-default"><span>Order Samples</span></button>
                  </div>
                </div>
              </form>
            </div>          
          </div>
          <button class="modal-close button button--close" @click="close()"><span class="sr-only">Close</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"/></svg></button>
        </div>
      </div>
    </div>
    </transition>`
}
const moduleWishlist = {
    namespaced: true,
    state () {
        return {
            items: JSON.parse(localStorage.getItem('limitlesswalls_wishlist_items')) || [],
            projects: JSON.parse(localStorage.getItem('limitlesswalls_wishlist_projects')) || [],
            share: []
        }
    },
    mutations: {
        ADD_ITEM(state, payload) {
            const item = payload.item;
            const itemFound = state.items.findIndex(row => (
                row.id === item.id &&
                row.variantId === item.variantId &&
                row.project === item.project &&
                row.type === item.type
            ));
            if(itemFound === -1) {
                state.items.push(item);
                const event = new Event('wishlist:autosave');
                window.dispatchEvent(event);
            }
        },
        LOAD_ITEMS(state, payload) {
            state.items = payload.items;
        },
        REMOVE_ITEM(state, payload) {
            const item = payload.item;
            const itemFound = state.items.findIndex(row => (
                row.id === item.id &&
                row.variantId === item.variantId &&
                row.type === item.type
            ));
            if (itemFound > -1) {
                state.items.splice(itemFound, 1);
                if(state.items.length > 0) {
                    const event = new Event('wishlist:autosave');
                    window.dispatchEvent(event);
                }
            }
        },
        CLEAR_ITEMS(state) {
            state.items = []
        },
        SAVE_ITEMS(state) {
            const parsed = JSON.stringify(state.items);
            localStorage.setItem('limitlesswalls_wishlist_items', parsed);
        },
        ADD_PROJECT(state, payload) {
            const project = payload.project;
            const projectFound = state.projects.findIndex(row => (
                row.name === project.name
            ));
            if(projectFound === -1) {
                state.projects.push(project);
            }
        },
        REMOVE_PROJECT(state, payload) {
            const project = payload.project;
            const projectFound = state.projects.findIndex(row => (
                row.id === project.id
            ));
            if(projectFound > -1) {
                state.projects.splice(projectFound, 1);
            }
        },
        SHARE_PROJECT(state, payload) {
            state.share = payload.project;
            const event = new Event('wishlist:share');
            window.dispatchEvent(event);
        },
        LOAD_PROJECTS(state, payload) {
            state.projects = payload.projects;
        },
        SAVE_PROJECTS(state) {
            const parsed = JSON.stringify(state.projects);
            localStorage.setItem('limitlesswalls_wishlist_projects', parsed);
        }
    },
    getters: {
        items (state) {
            return state.items.filter((item) => item.hasOwnProperty('project') && item.project);
        },
        projects (state) {
            return state.projects.sort((a,b) => {
                return new Date(b.date) - new Date(a.date);
            });
        },
        shared (state) {
            return state.share;
        }
    },
    actions: {
        clear(wishlist) {
            wishlist.commit('CLEAR_ITEMS')
            wishlist.commit('SAVE_ITEMS')
        },
        add(wishlist, item) {
            if(item) {
                wishlist.commit('ADD_ITEM', item)
                wishlist.commit('SAVE_ITEMS')
            }
        },
        load(wishlist, items) {
            if(items) {
                wishlist.commit('LOAD_ITEMS', items)
                wishlist.commit('SAVE_ITEMS')
            }
        },
        remove(wishlist, item) {
            if(item) {
                wishlist.commit('REMOVE_ITEM', item)
                wishlist.commit('SAVE_ITEMS')
            }
        },
        addProject(wishlist, data) {
            if(data) {
                wishlist.commit('ADD_PROJECT', data)
                wishlist.commit('SAVE_PROJECTS')
            }
        },
        loadProjects(wishlist, data) {
            if(data) {
                wishlist.commit('LOAD_PROJECTS', data)
                wishlist.commit('SAVE_PROJECTS')
            }
        },
        shareProject(wishlist, data) {
            if(data) {
                wishlist.commit('SHARE_PROJECT', data)
            }
        },
        removeProject(wishlist, data) {
            if(data) {
                wishlist.commit('REMOVE_PROJECT', data)
                wishlist.commit('SAVE_PROJECTS')
            }
        }
    }
}
const moduleModal = {
    namespaced: true,
    state () {
        return {
            show: false,
            modalBody: '',
            modalHeader: '',
            modalFooter: '',
            modalClass: '',
        }
    },
    getters: {
        show(state) {
            return state.show
        },
        modalClass(state) {
            return state.modalClass
        },
        modalHeader(state) {
            return state.modalHeader
        },
        modalBody(state) {
            return state.modalBody
        },
        modalFooter(state) {
            return state.modalFooter
        }
    },
    mutations: {
        OPEN(state) {
            state.show = true;
        },
        CLOSE(state) {
            state.show = false;
        },
        SET(state, payload) {
            state.modalBody = payload.modalBody;
            state.modalHeader = payload.modalHeader;
            state.modalFooter = payload.modalFooter;
            state.modalClass = payload.modalClass;
        }
    },
    actions: {
        open(modal) {
            modal.commit('OPEN')
        },
        close(modal) {
            modal.commit('CLOSE')
        },
        set(modal, data) {
            modal.commit('SET', data)
        }
    }
}
const moduleMessages = {
    namespaced: true,
    state () {
        return {
            message: null,
            type: null
        }
    },
    getters: {
        message(state) {
            return state.message
        },
        type(state) {
            return state.type
        }
    },
    mutations: {
        SET(state, payload) {
            state.message = payload.message;
            state.type = payload.type;
        },
        CLOSE(state) {
            state.message = null;
            state.type = null;
        },
    },
    actions: {
        set(message, data) {
            message.commit('SET', data)
        },
        close(message) {
            message.commit('CLOSE')
        },
    }
}
const store = Vuex.createStore({
    modules: {
        wishlist: moduleWishlist,
        modal: moduleModal,
        messages: moduleMessages
    }
})
window.store = store

const AdobeClientPlugin = {
    install(app, options) {
        const defaultUrl = '/products';
        const pushToDataLayer = (data) => {
            let timer = null;
            let count = 0;
            let dataLayer = window.dataLayer;
            timer = setInterval(() => {
                if(dataLayer) {
                    clearInterval(timer);
                    dataLayer = window.dataLayer;
                    dataLayer.push(data);
                    console.log("Data Layer"+" :"+JSON.stringify(data, null, " "));
                } else {
                    count += 1000;
                    if (count > 9000) clearInterval(timer);
                }
            },1000);
        };
        const pushToKlaviyo = (item) => {
            let timer = null;
            let count = 0;
            timer = setInterval(() => {
                if(_learnq) {
                    clearInterval(timer);
                    _learnq.push(['track', 'Viewed Product', item]);
                    _learnq.push(['trackViewedItem', {
                        Title: item.Name,
                        ItemId: item.ProductID,
                        ImageUrl: item.ImageURL,
                        Url: item.URL,
                        Metadata: {
                            Brand: item.Brand,
                            Price: item.Price,
                            Type: item.ProductType
                        }
                    }]);
                    console.log("Viewed Product"+" :"+JSON.stringify(item, null, " "));
                } else {
                    count += 1000;
                    if (count > 9000) clearInterval(timer);
                }
            },1000);
        };
        app.config.globalProperties.remoteApiUrl = 'https://direct.limitlesswalls.com/lwcontract/';
        app.config.globalProperties.backendApiUrl = 'https://direct.limitlesswalls.com/';
        app.config.globalProperties.wishlistApiUrl = 'https://wishlist.limitlesswalls.com/';
        app.config.globalProperties.adobeApiSearchUrl = 'https://direct.limitlesswalls.com/llw/Search.php';
        app.config.globalProperties.adobeApiMetadataUrl = 'https://direct.limitlesswalls.com/llw/Metadata.php';
        app.config.globalProperties.xApiFilters = {
            'locale': 'en-US',
            'search_parameters': {
                thumbnail_size: 240,
                filters_content_type_photo: 1,
                filters_image_width: 4500,
                filters_gentech: 'false',
                filters_premium: 'false'
            }
        };
        app.config.globalProperties.cartAddUrl = '/cart/add.js';
        app.config.globalProperties.previewUrl = 'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos/?frame=canvas2&style=style1&size=600&url=';
        app.config.globalProperties.canvasUrls = {
            'small': [
                'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos?frame=wall1&style=small&size=1000&check=false&url=',
                'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos?frame=wall2&style=small&size=1000&check=false&url='
            ],
            'medium': [
                'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos?frame=wall1&style=medium&size=1000&check=false&url=',
                'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos?frame=wall2&style=medium&size=1000&check=false&url='
            ],
            'large': [
                'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos?frame=wall1&style=large&size=1000&check=false&url=',
                'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos?frame=wall2&style=large&size=1000&check=false&url='
            ],
            'xl': [
                'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos?frame=wall1&style=xl&size=1000&check=false&url=',
                'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos?frame=wall2&style=xl&size=1000&check=false&url='
            ],
            'xxl': [
                'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos?frame=wall1&style=xxl&size=1000&check=false&url=',
                'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos?frame=wall2&style=xxl&size=1000&check=false&url='
            ]
        };
        app.config.globalProperties.fetchHeaders = new Headers({'pragma':'no-cache','cache-control':'no-store','Content-Type':'application/json'});
        app.config.globalProperties.decodeEntity = (input) => {
            let textarea = document.createElement("textarea");
            textarea.innerHTML = input;
            return textarea.value;
        };
        app.config.globalProperties.cloneObject = (o) => {
            return JSON.parse(JSON.stringify(o));
        }
        app.config.globalProperties.formatCurrency = (amount) => {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            }).format(amount/100);
        };
        app.config.globalProperties.capitalize = (text) => {
            return text.toLowerCase()
                .split(' ')
                .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                .join(' ');
        };
        app.config.globalProperties.getAspectRatio = (width, height) => {
            let ratio = null;
            const ratios = [0.33, 0.67, 1, 1.5, 3];
            const realRatio = width / height;
            ratios.forEach((item) => {
                if(ratio === null ||  Math.abs(realRatio - ratio) > Math.abs(item - realRatio)) {
                    ratio = item;
                }
            })
            return '' + ratio;
        };
        app.config.globalProperties.errorMessage = (message) => {
            return `<ul class="messages"><li class="error-msg"><span>${message}</span></li></ul>`
        };
        app.config.globalProperties.successMessage = (message) => {
            return `<ul class="messages"><li class="success-msg"><span>${message}</span></li></ul>`
        };
        app.config.globalProperties.updateDataLayer = (data) => {
            pushToDataLayer(data);
        };
        app.config.globalProperties.getItemImage = (properties) => {
            let img = null;
            if(properties) {
                if(properties.hasOwnProperty('_cropped_image') && properties['_cropped_image']) {
                    img = properties['_cropped_image'];
                } else if(properties.hasOwnProperty('_canvas_image') && properties['_canvas_image']) {
                    img = properties['_canvas_image'];
                } else if(properties.hasOwnProperty('_original_image') && properties['_original_image']) {
                    img = properties['_original_image'];
                }
            }
            return img;
        };
        app.config.globalProperties.updateMetas = (product, isStatic) => {
            // Fixed Price products
            isStatic = (typeof isStatic === 'undefined') ? false : isStatic;
            const productUrl = window.location.href.split('?')[0];
            let meta_description = '';
            if(product.hasOwnProperty('meta_description') && product.meta_description) {
                meta_description = product.meta_description;
            } else if(product.hasOwnProperty('description') && product.description) {
                meta_description = product.description;
            } else {
                meta_description = product.title;
            }
            if(!isStatic) {
                if(product.meta_title) {
                    document.querySelector('title').innerText = product.title;
                } else if(product.title) {
                    document.querySelector('title').innerText = product.title;
                }

                if(meta_description !== '') {
                    let metaTag = document.querySelector('meta[name="description"]');
                    if(metaTag) {
                        metaTag.setAttribute("content", meta_description);
                    } else {
                        let metaTag = document.createElement('meta');
                        metaTag.name = "description";
                        metaTag.content = meta_description;
                        document.head.appendChild(metaTag);
                    }
                }
            }

            setTimeout(() => {
                try {
                    // Insert canonical on product pages

                    let link = document.querySelector('link[rel="canonical"]');
                    if(!link) {
                        let link = document.createElement('link');
                        link.setAttribute('rel', 'canonical');
                        link.href = productUrl;
                        document.head.appendChild(link);
                    } else {
                        link.setAttribute('href', productUrl);
                    }

                    const schema = {
                        "@context": "http://schema.org/",
                        "@type": "Product",
                        "name": product.title,
                        "image": isStatic ? product.featured_image : product.url,
                        "url": productUrl,
                        "description": meta_description,
                        "brand": {
                            "@type": "Thing",
                            "name": "Limitless Walls"
                        },
                        "offers": [
                            {
                                "@type": "Offer",
                                "availability": "http://schema.org/InStock",
                                "price": Number(document.getElementById('hidden_product_price').value),
                                "priceCurrency": "USD",
                                "url": productUrl
                            }
                        ]
                    };

                    const script = document.createElement('script');
                    script.setAttribute('type', 'application/ld+json');
                    script.textContent = JSON.stringify(schema);
                    document.head.appendChild(script);
                } catch (e) {
                    console.error(e);
                }
            },250);

            setTimeout(() => {
                try {
                const productData = {
                    'pageType': 'Product',
                    'event': 'Product',
                    'products': [{
                        'id': product.id,
                        'sku': product.id,
                        'productType': product.type,
                        'name': product.title,
                        'price': document.getElementById('hidden_product_price').value,
                        'imageURL': isStatic ? product.featured_image : product.url,
                        'productURL': productUrl
                    }]
                };
                pushToDataLayer(productData);
                } catch (e) {
                    console.error(e);
                }
                try {
                    const klaviyoItem = {
                        Name: product.title,
                        ProductID: product.id || 'custom',
                        ImageURL: isStatic ? product.featured_image : product.url,
                        URL: productUrl,
                        ProductType: product.type,
                        Brand: "Limitless Walls",
                        Price: "$"+document.getElementById('hidden_product_price').value
                    };
                    pushToKlaviyo(klaviyoItem);
                } catch (e) {
                    console.error(e);
                }
            },2000);
        };
        app.config.globalProperties.getProductUrl = (product) => {
            let url = null;
            const type = product.product_type ? product.product_type.toLowerCase() : null;
            if(product.hasOwnProperty('url_key') && product.url_key !== null) {
                url = product.url_key;
            } else if(product.hasOwnProperty('custom') && product.custom === true) {
                url = 'custom';
            } else if(product.hasOwnProperty('id') && product.id !== null) {
                url = product.id;
            }
            if(url && type) {
                if(type === 'sample') {
                    url = '/products/mural/' + url;
                } else {
                    url = '/products/' + type + '/' + url;
                }
            }
            return url;
        }
        app.config.globalProperties.getUrl = (product,type) => {
            let url = `${defaultUrl}/${type}/${product.id}`;

            if(product.hasOwnProperty('entity_id') && product.entity_id) {
                url = `${defaultUrl}/${type}/${product.url_key}`;
            } else {
                try {
                    const thumbnail_url = product.hasOwnProperty('thumbnail_url') ? btoa(product.thumbnail_url) : btoa(product.url);
                    const title = btoa(product.title)
                    url = `${defaultUrl}/${type}/${product.id}?image=${thumbnail_url}&title=${title}`;
                    if(!product.entity_id) {
                        url += '&updateImage=true';
                    }
                } catch (e) {

                }
            }

            return url;
        }
        app.config.globalProperties.observePdp = () => {
            let breakpoint = window.matchMedia('(min-width:768px)');
            const pdpBreakpointCheck = () => {
                if (breakpoint && breakpoint.matches === true ) {
                    let timer = null;
                    let count = 0;
                    timer = setInterval(() => {
                        $sezzle = document.querySelector('.product-header .price-box .sezzle-shopify-info-button');
                        if($sezzle) {
                            clearInterval(timer);
                            document.querySelector('.product-info .price-box').appendChild($sezzle);
                        } else {
                            count += 1000;
                            if (count > 5000) clearInterval(timer);
                        }

                    },1000);
                } else if (breakpoint.matches === false) {
                    let timer = null;
                    let count = 0;
                    timer = setInterval(() => {
                        $sezzle = document.querySelector('.product-info .price-box .sezzle-shopify-info-button');
                        if($sezzle) {
                            clearInterval(timer);
                            document.querySelector('.product-header .price-box').appendChild($sezzle);
                        } else {
                            count += 1000;
                            if (count > 5000) clearInterval(timer);
                        }

                    },1000);
                }
            }
            breakpoint.addListener(pdpBreakpointCheck.bind(this));
            pdpBreakpointCheck();
        }
        app.config.globalProperties.observeGrid = () => {
            const resizeObserver = new ResizeObserver(() => {
                const items = document.querySelectorAll('.products-grid.grid-mode > .item');
                if(items && items.length > 0) {
                    setTimeout(() => {
                        let height = document.querySelector('.products-grid.grid-mode > .item:first-child > a').clientHeight;
                        height +=  'px';
                        console.log('height: ',height);
                        items.forEach((item) => {
                            item.style.minHeight = height;
                        })
                    },150);
                }
            });
            resizeObserver.observe(document.querySelector('.products-grid.grid-mode'));
        }
    }
}
const pageErrorsEl = document.getElementById('pageMessages');
const globalErrorsApp = Vue.createApp({
    template: `<ul class="messages" v-if="message"><li :class="{'error-msg':type === 'error','success-msg':type === 'success'}"><ul><li><span>{{message}}</span></li></ul></li></ul>`,
    computed: {
        type() {
            return store.getters['messages/type'];
        },
        message() {
            return store.getters['messages/message'];
        },
    },
    methods: {
        close() {
            store.dispatch('messages/close')
        },
    }
})
globalErrorsApp.use(store);
if(pageErrorsEl) {
    globalErrorsApp.mount('#pageMessages');
}
const appCookies = Cookies.noConflict()
const modalApp = Vue.createApp({
    template: `<transition name="modal">
    <div class="modal-mask" v-if="showModal">
      <div class="modal-wrapper" :class="modalClass" @click="close()">
        <div class="modal-container" @click.stop="">
          <div class="modal-header" v-html="modalHeader"></div>
          <div class="modal-body" v-html="modalBody"></div>
          <div class="modal-footer" v-html="modalFooter"></div>
          <button class="modal-close button button--close" @click="close()"><span class="sr-only">Close</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"/></svg></button>
        </div>
      </div>
    </div>
    </transition>`,
    computed: {
        showModal() {
            return store.getters['modal/show'];
        },
        modalClass() {
            return store.getters['modal/modalClass'];
        },
        modalHeader() {
            return store.getters['modal/modalHeader'];
        },
        modalBody() {
            return store.getters['modal/modalBody'];
        },
        modalFooter() {
            return store.getters['modal/modalFooter'];
        }
    },
    methods: {
        close() {
            store.dispatch('modal/close')
        },
    }
})
modalApp.use(store);
modalApp.mount('#modal-app');
